import { defineMessages } from 'react-intl';

export default defineMessages({
    accountSyncTitle: {
        id: 'ml.quoteandbind.common.accountSync.title',
        defaultMessage: 'It looks like you\'ve been here before. Let\'s confirm your identity before continuing.'
    },
    enterLast4SSN: {
        id: 'ml.quoteandbind.common.accountSync.Enter the last 4 digits of your Social Security Number',
        defaultMessage: 'Enter the last 4 digits of your Social Security Number'
    },
    enterLast4SSNPlaceholder: {
        id: 'ml.quoteandbind.common.accountSync.placeholder',
        defaultMessage: '####'
    }
});
